import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy
} from '@angular/core';
import {
  BaseSetupTab,
  ControllerApiService,
  IComponentStateHistory,
  IValueChangedEvent,
  outputParams,
  REMOVED
} from '@nrwl/test-setup';
import { TwampReflectorTestService } from '../../twamp-reflector-test.service';
import { isNil } from 'lodash';
import { NgForm } from '@angular/forms';
import { TwampReflectorConfigMapping as ConfigFieldMapping } from '../../model/twamp-reflector-agent-model';
import {
  Device,
  DevicesService,
  IDeviceData,
  LmapService,
  TestMode,
  TestTypeValue
} from '@nrwl/common-lib';
import { ETHER_TYPE, REBOOT_SELECTION, VLAN_CONFIG_TYPE } from '../../model/model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'nrwl-twamp-reflector-setup',
  templateUrl: './twamp-reflector-setup.component.html',
  styleUrls: ['./twamp-reflector-setup.component.scss']
})
export class TwampReflectorSetupComponent implements OnInit, OnDestroy {
  @ViewChild('cidrInput') el: ElementRef;
  @Input() tab: BaseSetupTab;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreValues?: Function;
  @Input() previousOutput: outputParams;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreAgentBasedConfig?: Function;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  newTestMode = true;
  editMode = false;
  cloneMode = false;
  testName: string;
  outputs: Array<string>;
  config: any;
  customerName = '';
  technicianName = '';
  agentType = 'default';
  testType = TestTypeValue.TWAMP_REFLECTOR;
  selectedOriginator: Device;
  rebootOptions = REBOOT_SELECTION;
  testMode = TestMode.DEFAULT;
  etherTypesData = ETHER_TYPE;
  vlanConfigTypes = [];
  isJmepAgentType = false;
  formField = {
    reflectorName: null,
    reflectorMode: 'light',
    ipAddress: '192.168.2.10',
    ipVersion: 'v4',
    ipAddressV6: 'fc00::10',
    prefixV6: '64',
    gatewayV6: 'fc00::1',
    subnet: '255.255.255.0',
    gateway: '192.168.2.1',
    udpport: 50000,
    maxSessions: 5,
    maxFlows: 50,
    vlanConfig: 'untagged',
    svlan: null,
    etherType: '8100',
    cvlan: null,
    restartOnBoot: false,
    controlPort: 862
  };

  deviceData: IDeviceData;
  activity: any;
  deviceName: string;
  raiseConfirm = false;
  monitorStarted = false;
  holdingPattern = false; //true when waiting for confirmation test really got started without any errors
  actionMsg = null;
  errorMsg = null;
  errorIcon = 'warning';
  testNameisValid = true;
  isLoading = false;
  isNewTestConfig = true;
  isAllowPersist = false;
  selctedTestID = null;
  activeTabID = null;
  allActiveTestList = [];
  activeTestlist = [];
  savedTestConfigs = [];
  removeConfirm = false;
  ipVersionEnabled = true;
  testConfigs = [];
  maxConcurrentTestCount = 0;
  isExceedMaxTest = false;
  isnotUniqueIPConfig = false;
  mgmtPortTesting = false;
  isnotUniqueConfig = false;
  isLimitExceeded = false;
  sessionsConfig = {
    maxFlows: 5,
    maxSessions: 5
  };
  flowsConfig = {
    maxFlows: 50
  };
  isLicenseLoaded = false;
  jmepLicenseObj = null;
  jmepLicenseEnabled = false;
  badIpValues = ['', '0.0.0.0', '255.255.255.255', '::/0'];

  controlPortPattern =
    /^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
  vLanPattern = /^([1-9]|[1-9]\d{1,2}|[1-3]\d{3}|40[0-8]\d|409[0-5])$/;
  vLanPriorityPattern = /^([0-7]?)$/;
  vLanPriority = '0';
  ipv6PrefixLengthPattern = /^([1-9][0-9]?|1[01][0-9]|12[0-8])$/;
  ipv4SubnetPattern =
    /^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$/;
  ipv4Pattern =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  ipv6Pattern =
    /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    public setupService: TwampReflectorTestService,
    private readonly deviceService: DevicesService,
    private readonly controllerApiService: ControllerApiService,
    private readonly lmap: LmapService
  ) {}

  ngOnInit(): void {
    this.initializeData();
    this.newTestMode = this.setupService.mode === 'new';
    this.editMode = this.setupService.editMode;
    this.cloneMode = this.setupService.mode === 'clone';
  }

  initializeData(): void {
    this.restoreAgentBasedConfig(this.agentType);
    this.restoreFormValues();
  }

  restoreFormValues(): void {
    this.tab.form = this.form;
    this.config = this.tab.config;
    this.outputs = this.config.def.outputs;
    this.vlanConfigTypes = this.config.options[ConfigFieldMapping.VLAN_CONFIG].value;
    this.testName = this.restoreFieldValues(ConfigFieldMapping.ALIAS);
    this.customerName = this.restoreFieldValues(ConfigFieldMapping.CUSTOMER);
    this.technicianName = this.restoreFieldValues(ConfigFieldMapping.TECHINICIAN);
    this.agentType = this.restoreFieldValues(ConfigFieldMapping.AGENT_TYPE);
    this.selectedOriginator = this.restoreFieldValues(ConfigFieldMapping.SELECTED_ORIGINATOR);
    this.formField.reflectorMode = this.restoreFieldValues(ConfigFieldMapping.REFLECTOR_MODE);
    this.formField.ipAddress = this.restoreFieldValues(ConfigFieldMapping.ADDRESS);
    this.formField.subnet = this.restoreFieldValues(ConfigFieldMapping.SUBNET);
    this.formField.gateway = this.restoreFieldValues(ConfigFieldMapping.GATEWAY);
    this.formField.ipAddressV6 = this.restoreFieldValues(ConfigFieldMapping.ADDRESS_IPV6);
    this.formField.prefixV6 = this.restoreFieldValues(ConfigFieldMapping.PREFIX_V6);
    this.formField.gatewayV6 = this.restoreFieldValues(ConfigFieldMapping.GATEWAY_V6);
    this.formField.udpport = this.restoreFieldValues(ConfigFieldMapping.UDP_PORT) || 50000;
    this.formField.controlPort = this.restoreFieldValues(ConfigFieldMapping.CONTROL_PORT);
    this.formField.maxSessions = this.restoreFieldValues(ConfigFieldMapping.SESSIONS) || 5;
    this.formField.maxFlows = this.restoreFieldValues(ConfigFieldMapping.FLOWS) || 50;
    this.formField.vlanConfig = this.restoreFieldValues(ConfigFieldMapping.VLAN_CONFIG);
    this.formField.svlan = this.restoreFieldValues(ConfigFieldMapping.SVLAN_ID);
    this.formField.cvlan = this.restoreFieldValues(ConfigFieldMapping.CVLAN_ID);
    this.formField.etherType = this.restoreFieldValues(ConfigFieldMapping.ETHER_TYPE);
    this.formField.restartOnBoot = this.restoreFieldValues(ConfigFieldMapping.REBOOT);
    this.formField.ipVersion = this.restoreFieldValues(ConfigFieldMapping.IP_VERSION);
    if (this.selectedOriginator) {
      this.getAgentDetails();
    }
  }

  updateTestIdentity(event: {
    testName: string;
    customer: string;
    technician: string;
    isValidName: boolean;
  }): void {
    this.onDataEmit('alias', event.testName, event.isValidName);
    this.onDataEmit('customer', event.customer, true);
    this.onDataEmit('technician', event.technician, true);
  }

  onAgentChange(data: any): void {
    this.selectedOriginator = this.deviceService.findDeviceByID(data.originatorId);
    this.agentType = this.selectedOriginator.getModel();
    this.onDataEmit(ConfigFieldMapping.AGENT_TYPE, this.agentType, true);
    this.setupService.setOriginatorAgent(this.selectedOriginator);
    this.onDataEmit(ConfigFieldMapping.SELECTED_ORIGINATOR, this.selectedOriginator, true);
    this.restoreAgentBasedConfig(this.agentType);
    this.restoreFormValues();
  }

  getAgentDetails(): void {
    this.testConfigs = [];
    this.isJmepAgentType = this.agentType.includes('JMEP');
    this.deviceData = this.selectedOriginator.deviceData;
    this.activity = this.deviceData.phyId
      ? this.deviceData.activity[this.deviceData.phyId]
      : this.deviceData.activity;
    this.activeTestlist = this.getActiveTestlist();
    if (!this.isJmepAgentType) {
      this.deviceName = this.deviceData.nameId;
      this.getDeviceCapabilities();
      this.getRunningTestConfigs();
    } else {
      this.maxConcurrentTestCount = 1;
      this.formField.ipAddress = this.getIpAddress();
      this.formField.svlan =
        this.deviceData.capabilities.phy['test-vlan-id'] &&
        this.deviceData.capabilities.phy['test-vlan-id'] !== '-1'
          ? this.deviceData.capabilities.phy['test-vlan-id']
          : null;
      this.isEnabledJMEPLicencse();
      this.onDataEmit(ConfigFieldMapping.ADDRESS, this.formField.ipAddress, true);
      this.onDataEmit(ConfigFieldMapping.SVLAN_ID, this.formField.svlan, true);
    }
    setTimeout(() => {
      if (!this.editMode) {
        this.isLimitExceeded = this.isExceedsMaxlimit();
        this.onDataEmit(
          ConfigFieldMapping.SELECTED_ORIGINATOR,
          this.selectedOriginator,
          !this.isLimitExceeded
        );
      }
      this.isUniqueConfig();
    }, 100);
  }

  getDeviceCapabilities(): void {
    //Enable IpV6 based on capability
    if (this.deviceData) {
      //Ipv6 control
      let cap;
      if (this.deviceData.capabilities.diagnostics) {
        const index = this.agentType.indexOf('vPMA');
        if (this.deviceData.capabilities.diagnostics['reboot-allowed'] === 'true' && index != -1) {
          this.isAllowPersist = true;
        } else {
          this.isAllowPersist = false;
        }
      }
      const testPortPhyId = this.deviceData['phyId'];
      if (testPortPhyId) {
        //For QT
        const selList =
          this.formField.reflectorMode === 'light'
            ? 'twamp-light-reflector-list'
            : 'twamp-reflector-list';
        const capList = this.deviceData.capabilities[selList];
        for (const key in capList) {
          if (testPortPhyId === capList[key]['phy-id']) {
            cap = capList[key];
            break;
          }
        }
      } else {
        //vPMA
        cap = this.deviceData.capabilities['twamp-reflector'];
        // if (this.liteModeSelect) {
        //     cap = this.ep.extension.capabilities['twamp-light-reflector'];
        // }
      }

      if (cap) {
        if (this.agentType === 'QT600-10') {
          this.ipVersionEnabled = true;

          // MV-2567 if QT600-10 then max flows and sessions are not configurable. Show what is set in
          // capabilities and disable the field
          this.formField.maxSessions =
            cap['max-control-sessions-per-test'] || this.formField.maxSessions;
          this.formField.maxFlows = cap['max-flows-per-test'] || this.formField.maxFlows;
        } else {
          this.ipVersionEnabled = 'true' === cap.ipv6;
        }
        this.maxConcurrentTestCount = cap['max-concurrent-tests'];
        this.flowsConfig.maxFlows = parseInt(cap['max-flows-per-test'] || 50);
        this.sessionsConfig.maxSessions = parseInt(cap['max-control-sessions-per-test'] || 5);
      }
    }

    if (
      this.agentType.indexOf('vPMA') >= 0 &&
      this.deviceData.capabilities.system['management-port-testing'] === 'true' &&
      this.deviceData.mgmtIPaddress
    ) {
      this.mgmtPortTesting = true;
      if (this.ipv4Pattern.test(this.deviceData.mgmtIPaddress)) {
        this.formField.ipVersion = 'v4';
        this.formField.ipAddress = this.deviceData.mgmtIPaddress;
      } else {
        this.formField.ipVersion = 'v6';
        this.formField.ipAddressV6 = this.deviceData.mgmtIPaddress;
      }
    }
    this.maxFlowsChange();
  }

  //eslint-disable-next-line
  onReflectorModeChange($event: any): void {
    this.formField.reflectorMode = $event.value;
    this.onDataEmit(ConfigFieldMapping.REFLECTOR_MODE, this.formField.reflectorMode, true);
  }

  //eslint-disable-next-line
  onChangeVersion($event: any): void {
    this.formField.ipVersion = $event.value;
    this.onDataEmit(ConfigFieldMapping.IP_VERSION, this.formField.ipVersion, true);
  }

  ipAddressChange(): void {
    this.onDataEmit(ConfigFieldMapping.ADDRESS, this.formField.ipAddress, true);
  }

  subnetChange(): void {
    this.onDataEmit(ConfigFieldMapping.SUBNET, this.formField.subnet, true);
  }

  gatewayChange(): void {
    this.onDataEmit(ConfigFieldMapping.GATEWAY, this.formField.gateway, true);
  }

  ipaddressV6Change(): void {
    this.onDataEmit(ConfigFieldMapping.ADDRESS_IPV6, this.formField.ipAddressV6, true);
  }

  prefixV6Change(): void {
    this.onDataEmit(ConfigFieldMapping.PREFIX_V6, this.formField.prefixV6, true);
  }

  gatewayV6Change(): void {
    this.onDataEmit(ConfigFieldMapping.GATEWAY_V6, this.formField.gatewayV6, true);
  }

  controlPortChange(): void {
    this.onDataEmit(ConfigFieldMapping.CONTROL_PORT, this.formField.controlPort, true);
  }

  maxSessionChange(): void {
    this.onDataEmit(ConfigFieldMapping.SESSIONS, this.formField.maxSessions, true);
  }

  maxFlowsChange(): void {
    this.onDataEmit(ConfigFieldMapping.FLOWS, this.formField.maxFlows, true);
  }

  //eslint-disable-next-line
  onRebootChange($event: any): void {
    this.formField.restartOnBoot = $event.value;
    this.onDataEmit(ConfigFieldMapping.REBOOT, this.formField.restartOnBoot, true);
  }

  onVlanConfigChange(): void {
    this.onDataEmit(ConfigFieldMapping.VLAN_CONFIG, this.formField.vlanConfig, true);
    this.formField.svlan = '';
    this.formField.cvlan = '';
    this.onDataEmit(ConfigFieldMapping.SVLAN_ID, this.formField.svlan, true);
    this.onDataEmit(ConfigFieldMapping.CVLAN_ID, this.formField.cvlan, true);
  }

  onSVlanChange(): void {
    this.onDataEmit(
      ConfigFieldMapping.SVLAN_ID,
      this.formField.svlan,
      this.form.controls['sVlanInput']?.valid
    );
  }

  onCVlanChange(): void {
    this.onDataEmit(
      ConfigFieldMapping.CVLAN_ID,
      this.formField.cvlan,
      this.form.controls['cVlanInput']?.valid
    );
  }

  onCVlanEtherTypeChange(): void {
    this.onDataEmit(ConfigFieldMapping.ETHER_TYPE, this.formField.etherType, true);
  }

  // handle reflector light port range check
  // port range 1-65535, except for 5060
  //
  handleReflectorLightPortRange(): void {
    if (
      this.formField.udpport >= 1 &&
      this.formField.udpport <= 65535 &&
      this.formField.udpport != 5060
    ) {
      this.form.controls.udpport.setErrors(null);
    } else {
      this.form.controls.udpport.setErrors({ regex: 'wrong' });
    }
    this.onDataEmit(ConfigFieldMapping.UDP_PORT, this.formField.udpport, true);
  }

  isExceedsMaxlimit(): boolean {
    this.isExceedMaxTest = false;
    const reflectorRunningTest = this.activeTestlist.filter(obj => {
      return obj.status === 'running';
    });
    const maxTestCount = Number(this.maxConcurrentTestCount);
    let otherTests = 0;
    if (this.activity.tests && !this.isJmepAgentType) {
      Object.keys(this.activity.tests).forEach(key => {
        if (key !== 'twamp-reflector' && key !== 'twamp-light-reflector') {
          otherTests = otherTests + this.activity.tests[key].length;
        }
      });
    }
    const testCount = reflectorRunningTest.length + otherTests;
    if (Number(maxTestCount) <= Number(testCount)) {
      if (this.agentType === 'QT600-10') {
        if (
          reflectorRunningTest &&
          reflectorRunningTest[0] &&
          reflectorRunningTest[0].status === 'running'
        ) {
          this.isExceedMaxTest = true;
        } else {
          this.isExceedMaxTest = false;
        }
      } else {
        this.isExceedMaxTest = true;
      }
    }
    return this.isExceedMaxTest;
  }

  getActiveTestlist(): any {
    const runningTest = this.activity.tests;
    let activeTests = [];
    if (this.activity) {
      if (this.activity.status === 'running') {
        if (runningTest) {
          if (runningTest['twamp-reflector']) {
            activeTests = runningTest['twamp-reflector'];
            activeTests.map(test => {
              test.type = 'twamp-reflector';
              test.status = 'running';
            });
          }
          if (runningTest['twamp-light-reflector']) {
            const lightReflector = runningTest['twamp-light-reflector'];
            if (lightReflector) {
              lightReflector.map(test => {
                test.type = 'twamp-light-reflector';
                test.status = 'running';
              });
            }
            if (activeTests) {
              activeTests = activeTests.concat(lightReflector);
            } else {
              activeTests = lightReflector;
            }
          }
        }
      }
    }
    return activeTests;
  }

  getRunningTestConfigs(): any {
    let testList = this.activeTestlist.filter(obj => {
      return obj.status === 'running';
    });
    let initiatorTests = [];
    if (this.activity.tests['twamp-initiator']) {
      initiatorTests = this.activity.tests['twamp-initiator'];
      if (initiatorTests) {
        initiatorTests.map(test => {
          test.type = 'twamp-initiator';
        });
        if (testList) {
          testList = testList.concat(initiatorTests);
        } else {
          testList = initiatorTests;
        }
      }
    }
    this.allActiveTestList = testList;
    const testListCount = testList.length;
    for (let i = 0; i < testListCount; i++) {
      const testId = testList[i].id;
      this.controllerApiService
        .getTestConfig(testId, true)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {
          let scheduleId = null;
          if (response.status === 'success') {
            scheduleId = response.data.id;
            const testType = this.getTestType(scheduleId);
            const config = this.lmap.getTestOptions(
              testType,
              [
                'client-ip',
                'source-ip',
                'sender-ip',
                'subnet',
                'gateway',
                'reflector-udp-port',
                'max-connections',
                'max-flows',
                'twamp',
                'vlan-id',
                'inner-vlan-id'
              ],
              response.data.config
            );
            if (config) {
              const isExisting = this.testConfigs.some(el => {
                return el.id === scheduleId;
              });
              if (!isExisting) {
                config.testType = testType;
                config.id = scheduleId;
                if (testType === 'twamp-initiator' && config.twamp) {
                  const clientIp = JSON.parse(config.twamp);
                  config['source-ip'] =
                    clientIp['ietf-twamp:twamp']['twamp-client']['twamp-client-ctrl-connection'][0][
                      'client-ip'
                    ];
                }
                this.testConfigs.push(config);
              }
            }
          }
        });
    }
  }

  //eslint-disable-next-line
  getTestType(testID): any {
    const objIndex = this.allActiveTestList.findIndex(obj => obj.id == testID);
    return this.allActiveTestList[objIndex].type;
  }

  isUniqueConfig(): void {
    this.isnotUniqueConfig = false;
    this.isnotUniqueConfig = false;
    if (this.isNewTestConfig) {
      if (this.testConfigs && this.testConfigs.length > 0) {
        const currentConfig = [];
        currentConfig['ipAddress'] =
          this.formField.ipVersion === 'v4' ? this.formField.ipAddress : this.formField.ipAddressV6;
        let vlanNumber = this.formField.vlanConfig;
        if (this.agentType.indexOf('vPMA') != -1) {
          if (vlanNumber !== 'untagged') {
            currentConfig['vlanId'] = this.formField.svlan;
            if (vlanNumber === 'q_in_q') {
              currentConfig['cVlan'] = this.formField.cvlan;
            }
          }
        } else {
          vlanNumber = 'QTConfig';
          currentConfig['vlanId'] = this.formField.svlan;
        }
        const isExistingConfig = this.testConfigs.find(
          el => el['source-ip'] === currentConfig['ipAddress']
        );
        if (isExistingConfig) {
          if (vlanNumber === 'untagged') {
            if (isExistingConfig['source-ip'] === currentConfig['ipAddress']) {
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueIPConfig = false;
            }
          } else if (vlanNumber === 'tagged' || vlanNumber === 'QTConfig') {
            if (
              isExistingConfig['source-ip'] === currentConfig['ipAddress'] &&
              isExistingConfig['vlan-id'] === currentConfig['vlanId']
            ) {
              this.isnotUniqueConfig = true;
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueConfig = false;
              this.isnotUniqueIPConfig = false;
            }
          } else if (vlanNumber === 'q_in_q') {
            if (
              isExistingConfig['source-ip'] === currentConfig['ipAddress'] &&
              isExistingConfig['vlan-id'] === currentConfig['vlanId'] &&
              isExistingConfig['inner-vlan-id'] === currentConfig['cVlan']
            ) {
              this.isnotUniqueConfig = true;
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueConfig = false;
              this.isnotUniqueIPConfig = false;
            }
          }
        } else {
          this.isnotUniqueIPConfig = false;
          this.isnotUniqueConfig = false;
        }
      }
    }
    if (this.isnotUniqueIPConfig || this.isnotUniqueConfig) {
      this.form.controls.vlanConfigInput?.setErrors({ uniqueConfig: 'wrong' });
    } else {
      this.form.controls.vlanConfigInput?.setErrors(null);
    }
  }

  checkModeType(): void {
    if (this.formField.reflectorMode == 'full') {
      this.formField.reflectorMode = 'light';
    } else {
      this.formField.reflectorMode = 'full';
    }
  }

  reflectorVersionValid(): boolean {
    // Check the version of reflector, lite mode only supported on version >= 2.0
    if (
      this.selectedOriginator.getVersion()?.value &&
      !(this.selectedOriginator.getVersion().value.indexOf('1.0') === 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  reflectorTypeValid(): boolean {
    if (this.agentType === 'vPMA' || this.agentType === 'vPMA-L' || this.agentType === 'QT600-10') {
      return true;
    } else {
      return false;
    }
  }

  // eslint-disable-next-line
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }

  // eslint-disable-next-line
  restoreFieldValues(field: string): any {
    const data = this.stateHistory(this.componentId, field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  isEnabledJMEPLicencse(): void {
    this.controllerApiService
      .getLicense()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.isLicenseLoaded = true;
        if (response.status !== 'error') {
          if (response.data.licenses && response.data.licenses.length > 0) {
            this.jmepLicenseObj = response.data.licenses.find(
              o => o.featureName === 'EAX-TWAMP-JMEP'
            );
            if (this.jmepLicenseObj) {
              this.jmepLicenseEnabled = true;
            } else {
              this.onDataEmit(
                ConfigFieldMapping.SELECTED_ORIGINATOR,
                this.selectedOriginator,
                false
              );
            }
          }
        } else {
          this.onDataEmit(ConfigFieldMapping.SELECTED_ORIGINATOR, this.selectedOriginator, false);
        }
      });
  }

  getIpAddress(): string {
    let ipAddress = '';
    const testIP = this.deviceData.capabilities.phy['test-ip']
      ? this.deviceData.capabilities.phy['test-ip']
      : null;
    const mgmtIP = this.deviceData.capabilities.phy['assigned-ip']
      ? this.deviceData.capabilities.phy['assigned-ip']
      : null;
    if (testIP && !this.badIpValues.includes(testIP)) {
      ipAddress = testIP;
    } else if (mgmtIP && !this.badIpValues.includes(mgmtIP)) {
      ipAddress = mgmtIP;
    }
    return ipAddress;
  }

  ngOnDestroy(): void {
    // if (this.timeoutPromise) {
    //   Object.keys(this.timeoutPromise).forEach((key, index) => {
    //     this.timeout.cancel(key);
    //   });
    // }
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
